// extracted by mini-css-extract-plugin
export var container = "_dk-0";
export var infoIcon = "_dk-2";
export var internalLabel = "_dk-3";
export var titleRowCol = "_dk-1";